import { Col, Row, Text } from 'components';
import { useInfiniteScroll } from 'core';
import { Api } from 'lib';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Header, ReportPanel } from 'screens/Admin/components';
import { Filters, List, ReportsSummaryBar } from './components';

const Reports = ({}) => {
  const [reported, setReported] = useState(null),
    [entityType, setEntityType] = useState(''),
    [status, setStatus] = useState(''),
    [dataId, setDataId] = useState(null),
    [loading, setLoading] = useState(null),
    [pendingSummary, setPendingSummary] = useState(null),
    { reports } = useSelector((state) => state.admin),
    fetching = useRef(false),
    skip = useRef(reports.length),
    dispatch = useDispatch(),
    scrollId = 'admin-reports-list';

  useInfiniteScroll(scrollId, () => getReports);

  useEffect(() => {
    skip.current = reports?.length || 0;
  }, [reports]);

  useEffect(() => {
    skip.current = 0;
    setLoading(true);

    getReports(true);
  }, [reported, entityType, status]);

  function handleSelect(postId) {
    setDataId(postId);
  }

  async function getReports(newSearch) {
    if (fetching.current) return;
    fetching.current = true;

    const res = await Api.post('/admin/getReports', {
      skip: skip.current || 0,
      reportedId: reported?._id,
      ...(entityType && { entityType }),
      ...(status && { status })
    });
    if (!res) return (fetching.current = false);

    dispatch({
      type: newSearch ? 'ADMIN_SET_REPORTS' : 'ADMIN_ADD_REPORTS',
      payload: res.reports
    });

    if (newSearch) setPendingSummary(res.pendingSummary);

    fetching.current = false;
    setLoading(false);
  }

  return (
    <Col noFlex wid="100%" ht="100vh" start>
      <Header>
        <Row center>
          <Text h3>Reports</Text>
        </Row>
      </Header>

      <Col start noFlex marg="54px 0 0" wid="100%" ht="100vh" id={scrollId} scrollY>
        <ReportsSummaryBar summary={pendingSummary} />

        <Filters owner={reported} setOwner={setReported} entityType={entityType} setEntityType={setEntityType} status={status} setStatus={setStatus} className="filters" />

        <List data={reports} dataId={dataId} onClick={handleSelect} loading={loading} />
      </Col>

      <ReportPanel dataId={dataId} setDataId={handleSelect} closeModal={() => setDataId(null)} />
    </Col>
  );
};

export default Reports;
